<template>
  <div class="header">
    <div class="patient-banner">
      <div class="patient-main-info">
        <h1 style="color: wheat;"><i class="fas fa-female"></i> Maternal Profile - ANC Clinic</h1>
        <div class="patient-id-section">
          <span class="patient-id">Patient: {{ patient.id+" - "+patient.name }}</span>
          <span class="gestational-age"
            >ID Number: {{ patient.id_number }}</span
          >
          <span class="last-visit">Age: {{ getAge(patient.dob) }}</span>
        </div>
      </div>
    </div>

    <!-- Navigation Tabs -->
    <anc_head />
  </div>
</template>

<script>
import anc_head from "./anc_head.vue";
import { generalApiRequest } from "../../../../api/apiIndex";
import getAge from "../../../../timezone/dob_to_age";  

export default {
  name: "ancheading",
  data() {
    return {
      showEditModal: false,
      patient: {
        id: "ANC-2023-07891",
        fullName: "Sarah Johnson",
        age: 32,
        dateOfBirth: "1991-05-15",
        maritalStatus: "Married",
        education: "Bachelor's Degree",
        occupation: "Teacher",
        husbandName: "Michael Johnson",
        husbandOccupation: "Engineer",
        address: "123 Main Street, Springfield, IL 62704",
        phone: "(555) 123-4567",
        emergencyContact: "(555) 987-6543 (Husband)",
        gestationalAge: 28,
        lastVisit: "2023-11-15",
        ancVisits: 5,
      },
    };
  },
  components: {
    anc_head,
  },

  methods: {
    getAge,
    async findPatient() {
      const uri = `get_patient_object_from_visit/${this.$route.params.visit_id}`;
      const response = await generalApiRequest(uri, "GET", {}, 1);
      this.patient = response.data;
      console.log(response);
    },
    activeTabChange() {
      this.loading = true;
    },
  },
  mounted() {
    this.findPatient();
  },
};
</script>

<style scoped>
.header {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 25px;
  overflow: hidden;
}
.patient-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.patient-main-info h1 {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 10px;
}

.patient-main-info h1 i {
  margin-right: 10px;
}
.patient-id-section {
  display: flex;
  gap: 30px;
  font-size: 16px;
}

.patient-id-section span {
  background: rgba(255, 255, 255, 0.2);
  padding: 5px 15px;
  border-radius: 20px;
  font-weight: 600;
}
@media (max-width: 576px) {
  .patient-banner {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .patient-id-section {
    flex-direction: column;
    gap: 10px;
  }

  .gp-score {
    grid-template-columns: 1fr;
  }

  .stats-bar {
    grid-template-columns: 1fr;
  }
}
</style>
